<template>
  <el-row type="flex" style="margin: 0 16px 16px 16px; flex-flow: row wrap">
    <el-button
      size="mini"
      target="_blank"
      :style="{
        fontFamily: fontSettings,
      }"
      :type="buttonOutline"
      :class="{ 'blue-button': buttonOutline === 'primary' }"
      @click="openScribe"
    >
      Open Scribe
    </el-button>
  </el-row>
</template>

<script>
export default {
  name: "MessageScribe",
  props: {
    buttonOutline: {
      type: String,
    },
  },
  data() {
    return {
      heidiOptions: {
        token: "",
        target: "#heidi",
        display: {
          position: "bottom-left",
        },
        onInit: this.onHeidiInit,
        onReady: this.onHeidiReady,
      },
      scriptURL: "",
      observer: null,
    };
  },
  computed: {
    fontSettings() {
      return this.$store.getters.settings.font;
    },
  },
  methods: {
    async openScribe() {
      if (this.heidiOptions.token === "") {
        await this.getToken();
      }

      this.loadWidget();
    },
    async getToken() {
      try {
        const result = await this.$store.dispatch("GET_SCRIBE_TOKEN");
        this.heidiOptions.token = result.token;
        this.scriptURL = result.scriptURL;
      } catch (err) {
        this.$notify.error({
          title: "Error",
          position: "bottom-right",
          message: "Error getting scribe token. Please click 'Open Scribe' again.",
        });
      }
    },
    loadWidget() {
      if (document.querySelector("script[src*='heidi.js']")) {
        this.openHeidi();
        return;
      }

      const script = document.createElement("script");
      script.async = true;
      script.src = this.scriptURL;
      document.head.appendChild(script);

      script.addEventListener("load", () => {
        // eslint-disable-next-line
        new Heidi(this.heidiOptions);
        this.openHeidi();
      });
    },
    openHeidi() {
      // eslint-disable-next-line
      Heidi.open();
    },
    closeHeidi() {
      // eslint-disable-next-line
      Heidi.close();
    },
    onHeidiInit() {
      console.log("Heidi initialized");
    },
    onHeidiReady() {
      // eslint-disable-next-line
      Heidi.onPushData(() => {
        this.$notify.info({
          title: "Info",
          position: "bottom-right",
          message: "Your note has been successfully saved!",
        });
      });

      // eslint-disable-next-line
      Heidi.onSessionStarted(() => {
        setTimeout(() => {
          const iframe = document.querySelector(".heidi-iframe");
          if (!iframe) return;

          const iframeDocument = iframe.contentDocument;
          if (!iframeDocument) return;

          const leftHeader = iframeDocument.getElementById("widget-header-left-section");
          const rightHeader = iframeDocument.getElementById("widget-header-right-section");

          const logoSVG = leftHeader?.querySelector("svg");
          if (logoSVG) {
            logoSVG.style.display = "none";
          }

          const buttons = rightHeader?.querySelectorAll("button");

          this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === "attributes" && mutation.attributeName === "data-state") {
                if (buttons?.[1]) {
                  const buttonClosed = buttons[1].getAttribute("data-state") === "closed";
                  if (!buttonClosed) {
                    const tooltipElement = buttons[1].nextElementSibling;
                    const tooltipDiv = tooltipElement?.querySelector("div");
                    if (tooltipDiv) {
                      tooltipDiv.childNodes[0].nodeValue = "Close";
                    }

                    const tooltipSpan = tooltipElement?.querySelectorAll("span");
                    if (tooltipSpan?.[1]) {
                      tooltipSpan[1].textContent = "Close";
                    }
                  }
                }

                const dropdownMenu = iframeDocument.querySelector('[role="menu"]');
                if (dropdownMenu) {
                  const menuItems = dropdownMenu.querySelectorAll('[role="menuitem"]');
                  if (menuItems.length === 3) {
                    menuItems[2].style.display = "none";
                  }
                }
              }
            });
          });

          this.observer.observe(iframeDocument, {
            childList: true,
            subtree: true,
            attributes: true,
          });
        }, 1000);
      });

      // eslint-disable-next-line
      Heidi.onTokenExpired(() => {
        this.getToken().then(() => {
          // eslint-disable-next-line
          Heidi.setToken(this.heidiOptions.token);
        });
      });
    },
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
.el-button {
  margin: 0 5px 5px 0;
  border-radius: 25px;

  &.active {
    background: transparent;
  }
}

.ui-beta {
  .el-button {
    margin: 0 5px 5px 0;
    border-radius: 8px;
    white-space: normal;
    text-align: left;

    &.blue-button {
      color: #4e6cce;
      background: #dce2f5;
      border-color: #4e6cce;

      &:hover {
        background: #4e6cce;
        color: #fff;
      }
    }
  }
}
</style>
